import type { CheckboxOption } from 'lua-web-components/dist/types/shared/types/checkbox.model';

export enum FieldType {
	INPUT = 'input',
	LU_BUTTON_INPUT = 'lu-button-input',
	LU_SELECT = 'lu-select',
	TYPEAHEAD = 'typeahead',
	DATE_TIME = 'datetime',
	TEXT_AREA = 'textarea',
	NUMBER = 'number',
	SWITCH = 'switch',
	MULTICHECKBOX = 'multicheckbox',
	RADIO = 'radio',
	LU_CHIP = 'lu-chip',
	LU_TEXT = 'lu-text-formly',
	DRAG_N_DROP_LIST = 'drag-n-drop-list',
	TOOGLE_BUTTON = 'toggle-button'
}

export enum InputType {
	TEXT = 'text',
	NUMBER = 'number',
	PASSWORD = 'password',
	SEARCH = 'search',
	COLOR = 'color'
}

export enum ErrorPosition {
	LEFT = 'left',
	RIGHT = 'right'
}

export interface ValueLabel {
	value: any;
	label: string;
	disabled?: boolean;
	ariaLabel?: string;
}

export type BulkCheckboxOptions = CheckboxOption & { enabled?: boolean; collapse?: boolean; counter?: boolean };
